import React, { memo } from 'react';
import { func, bool, arrayOf } from 'prop-types';
import { handleKeyDown } from '@widergy/utilitygo-forms-web';
import { UTButton, UTLabel, UTLoading } from '@widergy/energy-ui';
import { reduxForm } from 'redux-form';

import { message } from 'utils/stringUtils';
import { PAYMENT_BY_NIS } from 'constants/reduxForms';
import { appConfig } from 'config/customization';
import UTForm from 'app/components/UTForm';
import { fieldType } from 'types/formTypes';

import styles from './styles.module.scss';

const PaymentByNis = ({ handleSubmit, onGoToHome, submitFailed, invalid, fields, loading }) => (
  <UTLoading loading={loading}>
    <div className={styles.container}>
      <UTLabel large bold>
        {message('PublicPayment:publicPaymentByNisTitle')}
      </UTLabel>
      <UTLabel className={styles.subtitle}>{message('PublicPayment:publicPaymentByNisSubtitle')}</UTLabel>
      <form onKeyDown={handleKeyDown(handleSubmit)} onSubmit={handleSubmit} className={styles.form}>
        <UTForm fields={fields} />
        <div style={styles.buttonsContainer}>
          {appConfig.accountPaymentDocsForm.showCancelButton && (
            <UTButton secondary onPress={onGoToHome} className={styles.button}>
              {message('Commons:cancel')}
            </UTButton>
          )}
          <UTButton disabled={submitFailed && invalid} type="submit" className={styles.button}>
            {message('PublicPayment:searchPayments')}
          </UTButton>
        </div>
      </form>
    </div>
  </UTLoading>
);

PaymentByNis.propTypes = {
  handleSubmit: func,
  onGoToHome: func,
  submitFailed: bool,
  invalid: bool,
  fields: arrayOf(fieldType),
  loading: bool
};

export default reduxForm({ form: PAYMENT_BY_NIS })(memo(PaymentByNis));
